import { render, staticRenderFns } from "./UserCheckIcon.vue?vue&type=template&id=05a8e985&scoped=true&lang=pug"
import script from "./UserCheckIcon.vue?vue&type=script&lang=js"
export * from "./UserCheckIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a8e985",
  null
  
)

export default component.exports